const getFacilityCityStateZip = ({ facility, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (facility && facility['Company Address'] && facility['Company Address'].ID) {
    return `${facility['Company Address'].City}, ${facility['Company Address'].State} ${facility['Company Address']['Zip Code']}`.toUpperCase();
  }
  return null;
};

export default getFacilityCityStateZip;



// WEBPACK FOOTER //
// ./src/utils/print/getFacilityCityStateZip.js